export default {
    apiEndpointDev: 'http://localhost:5000/api/',

   apiEndpointTest: 'https://apitest.indialog.ai/api/',

    apiEndpointProd: 'https://api.indialog.ai/api/',

   /* apiEndpointTest: 'http://localhost:5000/api/',

    apiEndpointProd: 'http://localhost:5000/api/',*/

    signalrConnectionRetryInterval: 1000,

    imageChunkSize: 10240,

    messageLoadCount: 15,

    logoUrl: 'https://mediastore.inchatbot.com/17427bef-5404-4502-b9e6-3b0da1187624/Avatar/logo.png',

    uploadFileSizeLimit: 15728640 // 15 MB
}

 